import { cn } from '@/utils/common';
import Link from 'next/link';
import Image from 'next/image';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <div
      className={cn(
        'absolute bottom-0 left-0 w-full p-4 text-gray-500 text-sm bg-[#F8F7F7] flex items-center',
      )}
    >
      <div className="flex justify-between w-full">
        <div className="flex">
          <div className="mr-4">
            &copy; {year} <strong>MIGEPROF</strong>.
          </div>
          <div>
            {/* <Link
                    href="/privacy-and-terms/privacy"
                    className="mr-2 border-b-2 border-dotted"
                  >
                    Privacy Policy
                  </Link>
                  | */}
            <Link
              href="/privacy-and-terms/terms"
              className="ml-2 border-b-2 border-dotted"
            >
              Terms & Conditions
            </Link>
          </div>
        </div>
        <div className="ml-0">
          <Image
            src="/images/techouse.svg"
            alt="partner"
            width={80}
            height={32}
          />
        </div>
      </div>
    </div>
  );
}
